import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";

import img from "../imagenes/LOGO-Icontec-2019_hor_pos.png";
import fondo from "../imagenes/Degradado_ICONTEC-2019.png";

import "../../src/css/sb-admin-2.min.css";

const URL_AUTH = "https://autodiagnosticoback.azurewebsites.net/api/Auth";

const ADMIN_ID = "8600123361";

function Login({ onLoginSuccess }) {
  const navigate = useNavigate();

  const [identificacion, setIdentificacion] = useState("");
  const [codigo, setCodigo] = useState("");
  const [cargando, setCargando] = useState(false);
  const [mostrarCodigo, setMostrarCodigo] = useState(false);

  const guardarCookie = (nombre, valor) => {
    if (valor !== undefined && valor !== null) {
      const cookie = new Cookies();

      cookie.set(nombre, valor, {
        path: "/",
        sameSite: "lax",
        secure: window.location.protocol === "https:",
      });
    }
  };

  const postData = async (e) => {
    e.preventDefault();

    if (cargando) return;

    if (!identificacion.trim() || !codigo.trim()) {
      Swal.fire({
        title: "Campos obligatorios",
        text: "Ingresa tu usuario y contraseña.",
        icon: "warning",
        confirmButtonColor: "#005CA8",
      });
      return;
    }

    setCargando(true);

    Swal.fire({
      title: "Iniciando sesión...",
      text: "Espere un momento.",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await axios({
        method: "post",
        url: URL_AUTH,
        params: {
          identificacion: identificacion.trim(),
          codigo,
        },
        headers: {
          Accept: "application/json",
        },
        timeout: 30000,
      });

      const respuesta = response.data;

      Swal.close();

      // ======================================
      // ADMINISTRADOR
      // ======================================
      if (String(respuesta) === ADMIN_ID) {
        guardarCookie("nitNumber", respuesta);

        // Actualizar el estado de App.js
        if (onLoginSuccess) {
          onLoginSuccess();
        }

        await Swal.fire({
          title: "Bienvenido",
          text: "Administrador",
          icon: "success",
          confirmButtonText: "Continuar",
          confirmButtonColor: "#005CA8",
        });

        navigate("/InfoNormas", { replace: true });
        return;
      }

      // ======================================
      // VALIDAR RESPUESTA DEL CLIENTE
      // ======================================
      if (
        !respuesta ||
        typeof respuesta !== "object" ||
        Array.isArray(respuesta)
      ) {
        await Swal.fire({
          title: "Verifique la información",
          text: "Debe realizar la solicitud.",
          icon: "warning",
          confirmButtonColor: "#005CA8",
        });
        return;
      }

      // ======================================
      // VALIDAR TIPO DE CLIENTE
      // ======================================
      if (respuesta.clasE_CLIENTE !== "AFILIADO") {
        await Swal.fire({
          title: "Acceso no disponible",
          text: "Debe realizar la solicitud.",
          icon: "warning",
          confirmButtonText: "Ir a la tienda",
          confirmButtonColor: "#005CA8",
        });

        window.location.assign("https://tienda.icontec.org/");
        return;
      }

      // ======================================
      // GUARDAR COOKIES DEL AFILIADO
      // ======================================
      guardarCookie("cliente", respuesta.cliente);
      guardarCookie("nitNumber", respuesta.partY_NUMBER);
      guardarCookie("nit", respuesta.nit);
      guardarCookie("afiliado", respuesta.clasE_CLIENTE);
      guardarCookie("numeroCuenta", respuesta.numerO_CUENTA);
      guardarCookie("codigo", respuesta.cusT_ACCOUNT_ID);

      // Actualizar el estado de App.js
      if (onLoginSuccess) {
        onLoginSuccess();
      }

      // ======================================
      // BIENVENIDA Y REDIRECCIÓN
      // ======================================
      await Swal.fire({
        title: "Bienvenido",
        text:
          respuesta.CLIENTE ||
          respuesta.cliente ||
          "Has iniciado sesión correctamente.",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#005CA8",
      });

      navigate("/Resultados", { replace: true });
      return;
    } catch (error) {
      Swal.close();

      console.error(
        "Error de autenticación:",
        error.response?.status || error.code || "Error de conexión",
      );

      let mensaje = "Datos incorrectos. Verifica tu usuario y contraseña.";

      if (error.code === "ECONNABORTED") {
        mensaje = "El servidor tardó demasiado en responder.";
      } else if (!error.response) {
        mensaje = "No fue posible conectar con el servidor.";
      } else if (error.response.status >= 500) {
        mensaje = "Ocurrió un error en el servidor. Intenta nuevamente.";
      }

      await Swal.fire({
        title: "Datos incorrectos",
        text: mensaje,
        icon: "error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#005CA8",
      });
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-page" style={{ backgroundImage: `url(${fondo})` }}>
      <div className="login-overlay">
        <div className="login-card">
          <div className="login-header">
            <img src={img} className="login-logo" alt="ICONTEC" />

            <h1>Bienvenido</h1>
            <p>Ingresa tus credenciales para continuar</p>
          </div>

          <form onSubmit={postData}>
            <div className="login-field">
              <label htmlFor="identificacion">Usuario</label>

              <div className="login-input-wrapper">
                <span className="login-input-icon">
                  <i className="fas fa-user" />
                </span>

                <input
                  id="identificacion"
                  type="text"
                  className="form-control login-input"
                  placeholder="Ingresa tu usuario"
                  value={identificacion}
                  onChange={(e) => setIdentificacion(e.target.value)}
                  autoComplete="username"
                  disabled={cargando}
                  required
                  autoFocus
                />
              </div>
            </div>

            <div className="login-field">
              <label htmlFor="codigo">Contraseña</label>

              <div className="login-input-wrapper">
                <span className="login-input-icon">
                  <i className="fas fa-lock" />
                </span>

                <input
                  id="codigo"
                  type={mostrarCodigo ? "text" : "password"}
                  className="form-control login-input"
                  placeholder="Ingresa tu contraseña"
                  value={codigo}
                  onChange={(e) => setCodigo(e.target.value)}
                  autoComplete="current-password"
                  disabled={cargando}
                  required
                />

                <button
                  type="button"
                  className="login-toggle-password"
                  onClick={() => setMostrarCodigo((actual) => !actual)}
                  aria-label={
                    mostrarCodigo ? "Ocultar contraseña" : "Mostrar contraseña"
                  }
                >
                  <i
                    className={
                      mostrarCodigo ? "fas fa-eye-slash" : "fas fa-eye"
                    }
                  />
                </button>
              </div>
            </div>

            <button type="submit" className="login-button" disabled={cargando}>
              {cargando ? (
                <>
                  <span className="login-spinner" />
                  Validando...
                </>
              ) : (
                <>
                  Iniciar sesión
                  <i className="fas fa-arrow-right" />
                </>
              )}
            </button>
          </form>

          <div className="login-footer">
            <span className="login-footer-line" />
            <p>ICONTEC</p>
            <span className="login-footer-line" />
          </div>
        </div>

        <p className="login-copyright">Sistema de acceso · ICONTEC</p>
      </div>
    </div>
  );
}

export default Login;
